import createAsyncActions from '../../../../utilities/createAsyncActions';

import { GET_CLIENT_PROFILE_ENTRY_DETAILS } from '../../types';

export const {
  getClientProfileEntryDetails,
  getClientProfileEntryDetailsPending,
  getClientProfileEntryDetailsFulfilled,
  getClientProfileEntryDetailsRejected,
} = createAsyncActions(GET_CLIENT_PROFILE_ENTRY_DETAILS, 'getClientProfileEntryDetails');


// WEBPACK FOOTER //
// ./src/features/client-profile/actions/getActions/getClientProfileEntryDetailsActions.js